import { $api } from "../../../../services/request.config";
import { getSecondParentStatusesAction } from "../getSecondParentStatuses.action";


export const getSecondParentStatuses = () => async(dispatch) => {
    try {
        const response = await $api("v1/requests/restdays/disabled-child-care/second-parent-statuses");
        if (response.status === 200) {
            dispatch(getSecondParentStatusesAction(response.data));
        }
    } catch (error) {
        dispatch(getSecondParentStatusesAction([]));
    }
}
